import { Injectable } from '@angular/core';
import { OrderApprovalDecision } from '../../model';
import { Occ } from '../../occ';
import { Converter } from '../../util';

@Injectable()
export class OccOrderApprovalDecisionNormalizer implements Converter<Occ.OrderApprovalDecision, OrderApprovalDecision> {
  constructor() {}

  convert(source: Occ.OrderApprovalDecision, target?: OrderApprovalDecision): OrderApprovalDecision {
    if (target === undefined) {
      target = {
        ...(source as any),
      } as OrderApprovalDecision;
    }
    return target;
  }
}
